import React, { ReactChild } from 'react';
import useBranch from './hooks/useBranch';

interface Props {
  test: any;
  left: ReactChild | React.FC;
  right: ReactChild | React.FC;
  loadingFallback?: ReactChild | React.FC;
}

const Branch: React.FC<Props> = ({ test, left, right, loadingFallback = null }) => {
  const { testResult, loading } = useBranch(test);

  if (loading) return <>{loadingFallback}</>;

  return (
    <>
      {testResult && left}
      {!testResult && right}
    </>
  );
};

export default Branch;
